import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@/components/ui";

/**
 * Accessible breadcrumb trail + BreadcrumbList JSON-LD.
 * items: [{ label, to }] — the last item is the current page (omit `to`).
 */
export default function Breadcrumbs({ items = [] }) {
  const ld = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.label,
      ...(it.to ? { item: `https://homecarematches.com${it.to}` } : {}),
    })),
  };
  return (
    <nav className="imm-crumbs" aria-label="Breadcrumb" data-testid="breadcrumbs">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(ld) }} />
      {items.map((it, i) => (
        <span key={i} className="crumb">
          {it.to ? (
            <Link to={it.to} data-testid={`crumb-${i}`}>{it.label}</Link>
          ) : (
            <span className="current" aria-current="page" data-testid={`crumb-${i}`}>{it.label}</span>
          )}
          {i < items.length - 1 ? <Icon name="chevron-right" size={14} /> : null}
        </span>
      ))}
    </nav>
  );
}
